import { InjectionToken } from '@angular/core';

export const HTTP_BASE_URL = new InjectionToken<string>('HTTP_BASE_URL');

// Empty keeps task-server calls relative, so they go to HTTP_BASE_URL.
export const TASK_SERVER_BASE_URL = new InjectionToken<string>(
  'TASK_SERVER_BASE_URL',
  { providedIn: 'root', factory: () => '' }
);
